
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[code]",
      function () {
        return require("private-next-pages/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[code]"])
      });
    }
  